export enum languages {
	FR = 'fr',
	EN = 'en'
}

export enum languagesFullName {
	FR = 'Français',
	EN = 'Anglais'
}